export default __webpack_public_path__ + "images/icons/apple_icon-fbf794b51f1009fa618c2afa90bf650d.svg";